import React from 'react';
import { FiUser } from 'react-icons/fi';

// ===== Props Interface Start =====
interface ProfileImageProps {
  fullName?: string | null;
  profileImage?: string | null;
}
// ===== Props Interface End =====

const ProfileImage: React.FC<ProfileImageProps> = ({ fullName, profileImage }) => {

  // ===== Initials Logic Start =====
  const getInitials = () => {
    if (!fullName || fullName.trim() === "") return null;
    const parts = fullName.trim().split(" ");
    const first = parts[0]?.charAt(0) ?? "";
    const last = parts[parts.length - 1]?.charAt(0) ?? "";
    return (first + last).toUpperCase();
  };
  // ===== Initials Logic End =====

  const initials = getInitials();

  return (
    <div className="profile-image w-full h-full">
      {/* ===== Profile Image Start ===== */}
      {profileImage ? (
        <img src={profileImage} alt="Profile" className="profile-img w-full h-full object-cover rounded-full" />
      ) : initials ? (
        <div className="w-full h-full text-sm font-semibold text-white flex justify-center items-center rounded-full bg-[#6c5ffc]">
          {initials}
        </div>
      ) : (
        <div className="w-full h-full text-white flex justify-center items-center rounded-full bg-[#6c5ffc]">
          <FiUser size={18} />
        </div>
      )}
      {/* ===== Profile Image End ===== */}
    </div>
  );
};

export default ProfileImage;